import React, {useState, useRef, useEffect} from 'react';
import { Container, InputUnit, InputContainer, ContainerOperationMode, ContainerState, ContainerImage } from './styles'
import { NumberInput } from '../styles';

// import State from '../State';
// import OperationMode from '../OperationMode';
// import PumpImage from '../PumpImage';

import { State, OperationMode, PumpImage } from '../../Components';

/**
 * Componente para o Card
 * @returns {ReactComponentElement} 
 * @param {boolean} isNewValue caso seja um novo valor inserido pelo usuário
 * @param {boolean} isNewState caso seja um novo estado inserido pelo usuário
 * @param {boolean} isNewOperationMode caso seja um novo modo de operação inserido pelo usuário
 */
const CardPump = ({name, pump, fatherName, active, addComand, isNewValue, isNewState, isNewOperationMode}) => {
    const MododeOperacao = useRef(pump?.filter(item => {return (item.variavel.name.includes('Modo de operação')) }))
    const PumpState = useRef(pump?.filter(item => {return (item.variavel.name.includes('State'))} ))
    const Pumpvazao = useRef(pump?.filter(item => {return (item.variavel.name.includes('Vazão'))} ))
    
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [currentValue, setCurrentValue] = useState(0);
    const [currentState, setCurrentState] = useState(0);
    const [currentOperationMode, setCurrentOperationMode] = useState(null)

    useEffect(()=>{
        MododeOperacao.current = pump?.filter(item => {return (item.variavel.name.includes('Modo de operação'))} );
        MododeOperacao.current = MododeOperacao.current[0]
        PumpState.current = pump?.filter(item => {return (item.variavel.name.includes('State'))} );
        PumpState.current = PumpState.current[0]
        Pumpvazao.current = pump?.filter(item => {return (item.variavel.name.includes('Vazão'))} );
        Pumpvazao.current = Pumpvazao.current[0]

        setSelectedUnit(Pumpvazao.current?.variavel.unit);
        setCurrentValue(Pumpvazao.current?.variavel.valor !== null ? Pumpvazao.current?.variavel.valor : 0);
        setCurrentState(parseInt(PumpState.current?.variavel.valor) === 1);
        setCurrentOperationMode(parseInt(MododeOperacao.current?.variavel.valor));
    },[pump])

    // Método para alterar o modo de operação
    const changeOperationMode = (newState) => {
        ComandConstructor(MododeOperacao.current?.variavel.id, newState, MododeOperacao.current?.variavel.valor, MododeOperacao.current?.variavel.name,
            ()=>{setCurrentOperationMode(MododeOperacao.current?.variavel.valor)}, 'modo');
            setCurrentOperationMode(newState);
    }
    
    // Método para alterar o state
    const changePumpState = (newState) => {
        ComandConstructor(PumpState.current?.variavel.id, newState, PumpState.current?.variavel.valor, PumpState.current?.variavel.name, 
            () => {setCurrentState(parseInt(PumpState.current?.variavel.valor) === 1)}, 'state');
            setCurrentState(newState);
    }

    // Função para construir o comando e adicionar a lista
    const ComandConstructor = (comandId, value, oldvalue, childName, cancelComand, type) => {
        let newname = fatherName+'/'+childName
        addComand([comandId, value], oldvalue, newname, cancelComand, type);
    }
    // pointer-events:
    return (
        <Container>
            <ContainerOperationMode $Active={active}  onClick={(e) => e.stopPropagation()}>
                <OperationMode isNewValue={isNewOperationMode} State={currentOperationMode} onChange={(newState) => changeOperationMode(newState)}/>
            </ContainerOperationMode>

            <ContainerImage>
                <PumpImage/>
            </ContainerImage>
            
            <ContainerState $Active={active} onClick={(e) => e.stopPropagation()}>
                <State isNewValue={isNewState} State={currentState} onChange={(newState) => changePumpState(newState)}/>
            </ContainerState>
            <InputContainer $Active={active} onClick={(e) => e.stopPropagation()}>
                <NumberInput value={currentValue} 
                    isNewValue={isNewValue}
                    scale={1.2}
                    onBlur={() => ComandConstructor(Pumpvazao.current?.variavel.id, currentValue, Pumpvazao.current?.variavel.valor,
                    Pumpvazao.current?.variavel.name, () => setCurrentValue(Pumpvazao.current?.variavel.valor !== null ? Pumpvazao.current?.variavel.valor : 0))} 
                    type="number"
                    onChange={(e) => {setCurrentValue(e.target.value);}}/>
                <InputUnit $Active={active}>{name +' (' +selectedUnit+')'}</InputUnit>
            </InputContainer>
        </Container>
    );
}

export default CardPump;